import apiRoutes from "startups/apiRoutes";
import routes from "startups/routes";
import {
  submitData,
  catchHttpError,
  singleRelationshipToRequestFormat,
  extractContentsFromResponse,
} from "shared/api";
import { createActionFetcher } from "shared/redux-store/defaults";

function findAllProductsForOrderUnitsProducts(orderUnitsProducts, allProducts) {
  return orderUnitsProducts.map(oup => {
    return allProducts.find(p => p.id === oup.productId);
  });
}

export const fetchOrderUnitNew = createActionFetcher(
  "ORDER_UNIT_WIZARD_PRODUCTS",
  [apiRoutes.meProductsPath()],
);

// PLEASE NOTE: Keep in sync with orderUnitDetailsActions

export function localAddOrderUnitProduct(
  orderUnit,
  productId,
  productCount,
  allProducts,
) {
  const orderUnitsProducts = (orderUnit.orderUnitsProducts || []).concat({
    productId,
    productCount,
  });

  return {
    type: "LOCAL_ORDER_UNIT_WIZARD_PRODUCTS",
    orderUnitsProducts,
    products: findAllProductsForOrderUnitsProducts(
      orderUnitsProducts,
      allProducts,
    ),
  };
}

export function localUpdateOrderUnitProduct(
  orderUnit,
  productId,
  productCount,
  allProducts,
) {
  const orderUnitsProducts = orderUnit.orderUnitsProducts || [];
  const updatedOrderUnitProduct = orderUnitsProducts.find(oup => {
    return `${oup.productId}` === `${productId}`;
  });

  updatedOrderUnitProduct.productCount = productCount;

  return {
    type: "LOCAL_ORDER_UNIT_WIZARD_PRODUCTS",
    orderUnitsProducts,
    products: findAllProductsForOrderUnitsProducts(
      orderUnitsProducts,
      allProducts,
    ),
  };
}

export function localRemoveOrderUnitProduct(orderUnit, productId, allProducts) {
  const orderUnitsProducts = (orderUnit.orderUnitsProducts || []).filter(
    oup => {
      return `${oup.productId}` !== `${productId}`;
    },
  );

  return {
    type: "LOCAL_ORDER_UNIT_WIZARD_PRODUCTS",
    orderUnitsProducts,
    products: findAllProductsForOrderUnitsProducts(
      orderUnitsProducts,
      allProducts,
    ),
  };
}

function failBecauseEmpty() {
  return dispatch =>
    dispatch({
      type: "SUBMIT_ORDER_UNIT_WIZARD",
      payload: Promise.all([
        Promise.reject({
          response: {
            status: 422,
            data: {
              errors: [
                {
                  code: "EMPTY_REQUEST",
                  detail:
                    "Du musst mindestens ein Produkt zu der Bestelleinheit hinzufügen",
                },
              ],
            },
          },
        }),
      ]),
    }).catch(() => {});
}

export function submitLocalOrderUnit(orderUnit, extraOrderUnitAttributes = {}) {
  if (
    !orderUnit.orderUnitsProducts ||
    orderUnit.orderUnitsProducts.length === 0
  ) {
    return failBecauseEmpty();
  }

  const requestData = singleRelationshipToRequestFormat(
    "orderUnits",
    "orderUnitsProducts",
    orderUnit.orderUnitsProducts,
    {
      attributes: extraOrderUnitAttributes,
    },
  );

  return dispatch =>
    dispatch({
      type: "SUBMIT_ORDER_UNIT_WIZARD",
      payload: Promise.all([
        submitData(apiRoutes.createOrderUnitPath(), requestData, "POST"),
      ]).then(resourceResponses => {
        const orderUnitId = Object.keys(
          extractContentsFromResponse(resourceResponses, ["orderUnit"])
            .orderUnit,
        )[0];

        // Please note: This setTimeout() delays the dispatch to after redux actions
        // regarding _FULLFILLED get dispatched
        // This is deterministic and ensures the FULLFILLED action is applied completely
        // before any route changing occurs
        setTimeout(() => {
          dispatch({
            type: "REDIRECT",
            redirectTo: routes.editStartupsOrderUnitPath(orderUnitId, {
              isNew: 1,
            }),
          });
        });

        return resourceResponses;
      }),
    }).catch(catchHttpError);
}
